module.exports = __webpack_public_path__ + "static/media/quote2.3502cc59.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/quote2.png
// module id = 62
// module chunks = 0